// Lib
import React, { ReactElement, useEffect, useState } from 'react';
import VersionBlockingFullScreenPrompt from './VersionBlockingFullScreenPrompt';
import { fetchAppVersionStatus } from '../../utils/versionService';
import { getApplicationTypeSelector, selectAppVersion } from '../platformSelector';
import { useSelector } from 'react-redux';

const VersionBlockingManager = (): ReactElement | null => {
    const appType = useSelector(getApplicationTypeSelector);
    const appVersion = useSelector(selectAppVersion) || '0.0.0';

    const [isBlocked, setIsBlocked] = useState(false);

    useEffect(() => {
        (async () => {
            const response = await fetchAppVersionStatus(appVersion, appType);

            setIsBlocked(response.isBlocked);
        })();
    }, [appType, appVersion]);

    if (!isBlocked) return null;

    return <VersionBlockingFullScreenPrompt appType={appType} />;
};

export default VersionBlockingManager;
